import { createCleengDecodedToken, DecodedCleengToken } from '@24i/nxg-sdk-photon';
import { decodeBase64Token } from './utils';

export const decodedCleengToken = (token: string): DecodedCleengToken => {
    const decodedResult = decodeBase64Token(token);
    return createCleengDecodedToken(decodedResult);
};
